// extracted by mini-css-extract-plugin
module.exports = {"heroSection":"HeroSection_heroSection__ImwO9","title":"HeroSection_title___r2c1","description":"HeroSection_description__rotZg"};